import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useCceDetailModel } from "./cceDetailModel";
import { RouterParamType } from "@/model/navModel";
import { ICreditCardTabEnum } from "../../cceTypes";
import { BaseDetail } from "./base";
import { RelatedPerson } from "./related";
import { Files } from "./files";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useCceDetailModel(({ tabActive }) => [tabActive]);

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            case ICreditCardTabEnum.RELATED_PERSON:
                return <RelatedPerson {...detailsInfo} />;
            case ICreditCardTabEnum.FILES:
                return <Files {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: ICreditCardTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const action = <>
        <Button
            className={classname(ICreditCardTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(ICreditCardTabEnum.BASE_DETAIL)}
        >基本信息</Button>
        <Button
            className={classname(ICreditCardTabEnum.RELATED_PERSON)}
            type="link"
            shape="round"
            onClick={() => setTabActive(ICreditCardTabEnum.RELATED_PERSON)}
        >关系人</Button>
        <Button
            className={classname(ICreditCardTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActive(ICreditCardTabEnum.FILES)}
        >附件管理</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== ICreditCardTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}